import React, { useState, useEffect } from "react";
import "./LinkFamily.css";

import { db } from "../utils/User/include/Authorize";
import { useStateValue } from "../utils/Provider/StateProvider";

import SearchInput from "./SearchInput";
import Modal from "./Modal";
import { Link } from "react-router-dom";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

function LinkFamily() {
  const [{ myrelative, linkedFamily, user }, dispatch] = useStateValue();

  //component require:
  const [linkModal, showLinkModal] = useState(false);
  const [relativeOf, setRelativeOf] = useState("");
  const [relativeIs, setRelativeIs] = useState("");
  const [relatedAs, setRelatedAs] = useState("");
  const [description, setDescription] = useState("");
  const [formError, setFormError] = useState("");

  // Drag-drop handlers
  const [dragDivData, setDragDivData] = useState("");
  const [firstDragData, setFirstDragData] = useState("");
  const [secondDragData, setSecondDragData] = useState("");

  // Search handlers
  const [isFilterApplied, setFilterApplied] = useState(false);
  const [filterList, setFilterList] = useState();

  const [saveLinkFamily, setSaveLinkFamily] = useState(false);

  useEffect(() => {
    // Linked Family Members Details

    if (user) {
      db.collection(user.email)
        .doc("View")
        .collection("linkfamily")
        .onSnapshot((snapshot) => {
          const rel = [];

          snapshot.forEach((doc) => {
            let obj = doc.data();
            obj["uuid"] = doc.id;
            rel.push(obj);

            dispatch({
              type: "LINKED_FAMILY",
              linkedFamily: rel,
            });
          });
        });
    }
  }, [linkedFamily]);

  const filteringResult = (e, char) => {
    setFilterApplied(true);
    setFilterList(e);

    if (char.length === 0) {
      setFilterApplied(false);
    }
  };

  // Drag Drop Ftns
  const firstFamDraggedIn = (e) => {
    e.preventDefault();
    setFirstDragData(dragDivData);
  };

  const secondFamDraggedIn = (e) => {
    e.preventDefault();
    setSecondDragData(dragDivData);
  };

  const DivIsDragged = (e, data) => {
    e.preventDefault();
    setDragDivData(data);
  };

  // Random Position Generator:
  const randomX = () => {
    return Math.floor(Math.random() * (700 - 50 + 1)) + 50;
  };

  const randomY = () => {
    return Math.floor(Math.random() * (1000 - 20 + 1)) + 20;
  };

  // Save Link to Db:
  const saveLinkToDB = () => {
    if (!firstDragData) {
      setFormError("Drag Drop first family");
    } else if (!secondDragData) {
      setFormError("Drag Drop second family");
    } else if (!relativeOf) {
      setFormError("Related Of Field Required !");
    } else if (!relativeIs) {
      setFormError("Related Is Field Required !");
    } else if (!relatedAs) {
      setFormError("Related As Field Required !");
    } else if (!description) {
      setFormError("Description Required !");
    } else {
      setSaveLinkFamily(true);

      const obj = {
        from: firstDragData.uuid,
        to: secondDragData.uuid,
        relativeOf: relativeOf,
        fName: firstDragData.person_data[0].family_name,
        tName: secondDragData.person_data[0].family_name,
        relativeIs: relativeIs,
        relatedAs: relatedAs,
        description: description,
        position: { x: randomX(), y: randomY() },
      };
      console.log("Saving", obj);
      setFormError("");

      if (user) {
        db.collection(user.email).doc("View").collection("linkfamily").add(obj);

        setFirstDragData("");
        setSecondDragData("");
        setSaveLinkFamily(false);
        showLinkModal(false);
      } else {
        console.log("error in Saving to db ", user);
        setSaveLinkFamily(false);
      }
    }
  };

  // Delete link families:
  const deleteLink = (id) => {
    console.log("Deleting Link");
    if (user) {
      db.collection(user.email)
        .doc("View")
        .collection("linkfamily")
        .doc(id)
        .delete();
    }
  };

  return (
    <div className="linkfamily_main_container">
      <div className="custom_individualPerson_view_search_input_div">
        <SearchInput
          placeholder="Search your relative"
          width="100%"
          filterFrom={myrelative}
          onFilter={(e, char) => filteringResult(e, char)}
        />
      </div>

      <p className="linkfamily_family_count">
        {myrelative && myrelative.length} relatives found...
      </p>

      {isFilterApplied && myrelative && filterList.length === 0 && (
        <p className="no_match_caution_msg">No match found 😔</p>
      )}

      <div className="linkfamily_family_container">
        {/* <div className="blur_effect_left"></div> */}

        {myrelative &&
          !isFilterApplied &&
          Object.keys(myrelative).map(
            (i) =>
              myrelative[i].person_data[0] && (
                <div
                  className="card_div"
                  onDragStart={(e) => DivIsDragged(e, myrelative[i])}
                  onDoubleClick={() => {
                    setSecondDragData("");
                    setFirstDragData(myrelative[i]);
                  }}
                  onClick={() => {
                    setSecondDragData(myrelative[i]);
                  }}
                  draggable
                >
                  <p className="card_div_famName">
                    {myrelative[i].person_data[0].family_name}
                  </p>
                  <p className="card_div_famMembers">
                    {myrelative[i].person_data.length} members
                  </p>

                  <p className="card_div_personName">
                    {myrelative[i].person_data[0].name}...
                  </p>
                </div>
              )
          )}

        {isFilterApplied &&
          myrelative &&
          filterList.map((filter) =>
            Object.keys(myrelative).map((i) =>
              myrelative[i].person_data.map((person, index) =>
                filter === person.name ? (
                  <div
                    className="card_div"
                    onDragStart={(e) => DivIsDragged(e, myrelative[i])}
                    onDoubleClick={() => {
                      setSecondDragData("");
                      setFirstDragData(myrelative[i]);
                    }}
                    onClick={() => {
                      setSecondDragData(myrelative[i]);
                    }}
                    draggable
                  >
                    <p className="card_div_famName">
                      {myrelative[i].person_data[0].family_name}
                    </p>
                    <p className="card_div_famMembers">
                      {myrelative[i].person_data.length} members
                    </p>

                    <p className="card_div_personName">
                      {myrelative[i].person_data[0].name}...
                    </p>
                  </div>
                ) : null
              )
            )
          )}
        {/* <div className="blur_effect_right"></div> */}
      </div>

      <div className="linkfamily_drop_container">
        <div
          className="linkfamily_drop_dragDiv_here"
          onDragOver={(e) => firstFamDraggedIn(e)}
        >
          {!firstDragData && (
            <p className="linkfamily_drop_dragDiv_hint">
              Drag/Drop or Double Click
            </p>
          )}
          {!firstDragData && (
            <p className="linkfamily_drop_dragDiv_text">First Family</p>
          )}

          {firstDragData && (
            <p className="linkfamily_drop_dragDiv_active">
              {firstDragData.person_data[0].family_name} &nbsp;{" "}
              <span>
                <i class="fa fa-times" onClick={() => setFirstDragData("")}></i>
              </span>
            </p>
          )}
          {firstDragData && (
            <p className="linkfamily_drop_dragDiv_active">
              {firstDragData.person_data[0].name}...
            </p>
          )}
        </div>

        <div
          className="linkfamily_drop_dragDiv_here"
          onDragOver={(e) => secondFamDraggedIn(e)}
        >
          {!secondDragData && (
            <p className="linkfamily_drop_dragDiv_hint">
              Drag/Drop or Single Click
            </p>
          )}
          {!secondDragData && (
            <p className="linkfamily_drop_dragDiv_text">Second Family</p>
          )}
          {secondDragData && (
            <p className="linkfamily_drop_dragDiv_active">
              {secondDragData.person_data[0].family_name} &nbsp;{" "}
              <span>
                <i
                  class="fa fa-times"
                  onClick={() => setSecondDragData("")}
                ></i>
              </span>
            </p>
          )}
          {secondDragData && (
            <p className="linkfamily_drop_dragDiv_active">
              {secondDragData.person_data[0].name}...
            </p>
          )}
        </div>
      </div>

      {firstDragData && secondDragData && (
        <div className="linkFamily_button">
          <button onClick={() => showLinkModal(true)}>
            <i class="fa fa-link"></i> &nbsp; Create Link between them
          </button>
        </div>
      )}

      <h5 className="show_linked_family_div_title">
        Linked Members are displayed here !
      </h5>

      <div className="show_linked_family_div_container">
        {linkedFamily &&
          linkedFamily.map((i) => (
            <div className="show_link_family_card">
              <div className="show_link_family_card_delete_button_right">
                <i class="fa fa-trash" onClick={() => deleteLink(i.uuid)}></i>
              </div>

              <div className="show_link_family_card_row">
                <p className="show_link_family_card_mainTitle">
                  {i.relativeOf} <span>({i.fName})</span>
                </p>
                <i class="fa fa-link"></i>
                <p className="show_link_family_card_mainTitle">
                  {i.relativeIs} <span>({i.tName})</span>
                </p>
              </div>

              <div className="show_link_family_card_row">
                <p className="show_link_family_card_relatedAs">{i.relatedAs}</p>
              </div>

              <div className="show_link_family_card_row">
                <p className="show_link_family_card_description">
                  {i.description}
                </p>
              </div>
            </div>
          ))}
      </div>

      {linkModal && (
        <Modal
          title="Creating the link"
          onCloseHandler={() => showLinkModal(false)}
        >
          <div className="linkFamily_modal_container">
            <p>Few Steps to go ... </p>

            {/* <button onClick={() => check(firstDragData)}>check</button> */}

            <label>Relative of :</label>
            <br />
            <select
              value={relativeOf}
              onChange={(e) => setRelativeOf(e.target.value)}
            >
              <option defaultChecked>select Name</option>
              {firstDragData &&
                firstDragData.person_data.map((person) => (
                  <option value={person.name}>{person.name}</option>
                ))}
            </select>

            <br />
            <label>Relative Is :</label>
            <br />
            <select
              value={relativeIs}
              onChange={(e) => setRelativeIs(e.target.value)}
            >
              <option defaultChecked>select Name</option>
              {secondDragData &&
                secondDragData.person_data.map((person) => (
                  <option value={person.name}>{person.name}</option>
                ))}
            </select>

            <br />
            <label>Related as :</label>
            <br />
            <input
              type="text"
              placeholder="related as brother/mama etc"
              value={relatedAs}
              onChange={(e) => setRelatedAs(e.target.value)}
            />

            <br />
            <label>Description (if any) :</label>
            <br />
            <input
              type="text"
              placeholder="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <br />

            <button onClick={() => saveLinkToDB()}>
              {saveLinkFamily && (
                <AiOutlineLoading3Quarters className="loaderAnimation" />
              )}{" "}
              Create Link
            </button>

            <p className="error_missing_field">{formError}</p>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default LinkFamily;
